import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
/*
 * @Author: 刘怡 
 * @Date: 2022-04-08 14:31:14 
 * @Last Modified by: 刘怡
 * @Last Modified time: 2022-05-16 18:32:55
 */
import request from '@/utils/request';
/**
 * 理赔列表
 * @param {*} data 
 * @returns 
 */
export function claimsList(data) {
  return request.post('admin/insurance-claims/list', data);
}
/**
 * 理赔详情
 */
export function claimsDetail(data) {
  return request.post('admin/insurance-claims/detail', data).then(res => {
    res.configList.map(item => {
      item.isEdit = false;
      item.claimsParam = [];
      item.config.claimsSort.map(item2 => {
        let arr = [],
          arr2 = [];
        item2.isOpen = item2.claimsParamList.length > 9 ? false : true;
        item.claimsParam.push(item2.sortId);
        item2.claimsParamList.map((item3, index) => {
          if (item3.selected) {
            arr.push(item3.id);
          }
          item3.isOpen = index > 8 ? false : true;
          arr2.push(item3.id);
          if (arr.join(',') == arr2.join(',')) {
            item2.selected = true;
          } else {
            item2.selected = false;
          }
        });
      });
    });
    return res;
  });
}
/**
 * 新增或修改理赔基本信息
 */
export function claimsMode(data) {
  return request.post('admin/insurance-claims-edit/claimsmode', data);
}
/**
 * 理赔产品状态修改
 */
export function claimsStatus(data) {
  return request.post('admin/insurance-claims/status', data);
}
/**
 * 理赔产品新增(配置子集--详情)
 */
export function addClaimsItem(data) {
  return request.post('admin/insurance-claims/store', data);
}
/**
 * 理赔产品修改(配置子集--详情)
 */
export function editClaimsItem(data) {
  return request.post('admin/insurance-claims/edit', data);
}
/**
 * 理赔产品删除(配置子集--详情)
 */
export function delClaimsItem(data) {
  return request.post('admin/insurance-claims/delete', data);
}
/**
 * 理赔产品资源,根据理赔类型+保险id查询出对应的模版
 */
export function claimsItemTypeResource(data) {
  return request.post('admin/insurance-claims/resource', data);
}